import { render, staticRenderFns } from "./nodePage.vue?vue&type=template&id=79637118"
import script from "./nodePage.vue?vue&type=script&lang=js"
export * from "./nodePage.vue?vue&type=script&lang=js"
import style0 from "./nodePage.vue?vue&type=style&index=0&id=79637118&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports